import { Box, Divider, Text } from '@chakra-ui/react';
import React from 'react';

import { EmailSubscriptionGQLType } from 'types/dashboard-core-gqlTypes.generated';

import EmailSubscriptionsViewContainer from './emailSubscriptions/ViewContainer';
import { SlackInstallationsView } from './slack/SlackInstallationsView';
import { PageHeader } from 'packages/common-frontend/components/PageContainer';

const NotificationsViewContainer = ({
  borrowerId,
  creditFacilitySlugs,
  emailSubscriptions,
}: {
  borrowerId: string;
  creditFacilitySlugs: string[];
  emailSubscriptions: EmailSubscriptionGQLType[];
}) => {
  return (
    <Box>
      <PageHeader headerLabel="Manage Notifications" />
      <Text width="100%" mt="10px" fontSize="sm" align="left">
        Manage all slack and email notification settings across all Finley
        Dashboard features
      </Text>
      <Box>
        <Divider m="25px 0" orientation="horizontal" />
        <EmailSubscriptionsViewContainer
          creditFacilitySlugs={creditFacilitySlugs}
          emailSubscriptions={emailSubscriptions}
        />
        <Divider m="25px 0" orientation="horizontal" />
        <SlackInstallationsView borrowerId={borrowerId} />
      </Box>
    </Box>
  );
};

export default NotificationsViewContainer;
